import React from "react";
import { MessageBar, MessageBarType } from "@fluentui/react/lib/MessageBar";
import { ResourceStrings } from "../../../ResourceStrings";
import { Operation, operationHasMessage, operationMesageBarType } from "../../../store/operation";
import styled from "styled-components/macro";

export interface OperationNotificationProps {
  operation: Operation;
  resetOperation: () => void;
  className?: string;
}

export default function OperationNotification(props: OperationNotificationProps): JSX.Element {
  const { operation, resetOperation, className } = props;

  if (!operationHasMessage(operation)) {
    return null;
  }

  return <Wrapper className={className} messageBarType={operationMesageBarType(operation)}>
    <MessageBar
      messageBarType={operationMesageBarType(operation)}
      onDismiss={() => { resetOperation() }}
      dismissButtonAriaLabel={ResourceStrings.close()}
    >
      {operation.message}
    </MessageBar>
  </Wrapper>
}

const Wrapper = styled.div <{ messageBarType?: MessageBarType }>`
    border: solid 2px #0067b8;
    border-radius: 2px;
    margin: 0 2rem 2rem;
    width: auto;

    .ms-MessageBar {
      background-color: ${props => props.messageBarType === MessageBarType.info ? "#f4f9fb" : "inherit"}
    }
`;
